import { inject, Service } from '@angular/core';
import { Resolve } from '@angular/router';
import { DataAccessOwnerService } from '@h5s/data-access-owner';
import { OwnerGrid } from '@h5s/entities';
import { defer, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * Resolver per caricare le impostazioni dell'OwnerGrid prima di attivare le rotte che ne fanno uso.
 * Se le impostazioni sono già caricate, non fa nulla.
 * Se non sono caricate, chiama il metodo loadOwnerSettings() del FeatureOwnerService.
 */
@Service()
export class OwnerGridResolver implements Resolve<OwnerGrid> {
  /** Services */
  private readonly dataAccessOwnerService = inject(DataAccessOwnerService);

  resolve(): Observable<OwnerGrid> {
    return defer(() => {
      return this.dataAccessOwnerService.getOwnerGrid().pipe(take(1));
    });
  }
}
